<script>
	import { fade } from "svelte/transition";

	import PageSection from "../../components/PageSection.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;

	pageNumber.update((p) => pageIndex);
	document.title = pageTitle;

	window.onbeforeunload = null;
</script>

<PageSection>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">Thank you</h1>

			<p>
				Thank you for completing your questionnaire for the {projectSettings.classActionName}.
			</p>

			<p>
				<!-- 
                Your registration number is: <strong>{$model.RegistrationNumber}</strong>
            </p -->
			</p>
			<p>
				If you have any questions, please contact Shine Lawyers on {projectSettings.phoneNumber}, or at
				<a href="mailto:{projectSettings.emailAddress}" target="_blank" rel="noreferrer noopener"
					>{projectSettings.emailAddress}</a
				>.
			</p>
			<br />
		</div>

		<div class="col-md-8 col-sm-12">
			<h2 class="text-center">What happens next</h2>
			<p>
				If you consented to us obtaining your medical records from your General Practitioner(s) (GPs), you will
				shortly receive General Authority forms matching the number of GPs who treated you. These forms will be
				sent to you via DocuSign. Please complete this form for each of the relevant GPs.
			</p>
			<p>We thank you for your support and cooperation throughout this process. We will be in touch shortly.</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2,
	h3 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}
</style>
